export default "__VITE_ASSET__601d38b9__"